<template>
    <div class="users-repeater">
        <form
            v-if="Object.keys(schema).length"
            class="users-repeater__form form"
            @submit.prevent="submit"
        >
            <slot name="header"></slot>
            <div class="users-repeater__items" :data-count="users.length">
                <transition-group name="fade-down">
                    <UsersRepeaterItem
                        v-for="(user, idx) in users"
                        :key="idx"
                        v-model="users[idx]"
                        :schema="userSchema"
                        :can-delete="users.length > 1"
                        class="users-repeater__item"
                        @deleteUser="deleteUser(idx)"
                    />
                </transition-group>
                <Grid :gap-y="5">
                    <Column>
                        <button
                            type="button"
                            class="button users-repeater__trigger"
                            @click.prevent="addUser"
                        >
                            <IconPlus />
                            <span v-t="triggerText"></span>
                        </button>
                    </Column>
                </Grid>
                <ErrorList :error="error" />
                <Grid>
                    <Column :span="6">
                        <button
                            type="button"
                            class="button button--big button--fullwidth button--outlined"
                            @click.prevent="cancel"
                            v-text="$t('misc.cancel')"
                        />
                    </Column>
                    <Column :span="6">
                        <button
                            :disabled="loading"
                            :class="[
                                'button button--big',
                                'button--fullwidth',
                                { 'is-loading': loading },
                            ]"
                            v-text="$t('misc.save')"
                        />
                    </Column>
                </Grid>
            </div>
        </form>
    </div>
</template>

<script>
import UsersRepeaterItem from './UsersRepeaterItem';
import { ErrorList } from '@speechki-frontend/shared/ui/forms';
import { Grid, Column } from '@speechki-frontend/shared/ui/Grid';
import { IconPlus } from '@speechki-frontend/shared/ui/icons';

export default {
    name: 'UsersRepeater',
    components: {
        UsersRepeaterItem,
        ErrorList,
        Grid,
        Column,
        IconPlus,
    },
    provide() {
        return {
            languages: this.languagesArray,
        };
    },
    props: {
        schema: {
            type: Object,
            required: true,
        },
        languages: {
            type: Object,
            default: () => ({}),
        },
        loading: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Object,
            default: () => ({}),
        },
        triggerText: {
            type: String,
            default: 'misc.add',
        },
    },
    data() {
        return {
            users: [],
            initialUser: {
                email: null,
                roles: [],
                languages: [],
            },
        };
    },
    computed: {
        userSchema() {
            return this.schema.users.child.children;
        },
        languagesArray() {
            return Object.entries(this.languages).map(([id, label]) => ({ id, label }));
        },
    },
    mounted() {
        this.addUser();
    },
    methods: {
        addUser() {
            this.users.push({ ...this.initialUser });
        },
        deleteUser(idx) {
            this.users.splice(idx, 1);
        },
        cancel() {
            this.$emit('cancel');
        },
        submit() {
            const { users } = this;
            this.$emit('save', { users });
        },
    },
};
</script>

<style src="./UsersRepeater.scss" lang="scss"></style>
